import React, { lazy, Suspense, useState } from 'react';

import ShippingDiscountModal from '@/resources/components/cart/shipment/address/components/delivery/shippingDiscountModal/ShippingDiscountModal';
import ListProductsLoad from '@/resources/components/loads/ListProductsLoad';
import { IProductList } from '@/store/ducks/productLists/types';

const Products = lazy(() => import('@/resources/components/products/Products'));

interface FreeShippingSectionProps {
  freeShippingProducts: IProductList;
  order: any;
  listColor: string;
}

const FreeShippingSection: React.FC<FreeShippingSectionProps> = ({
  freeShippingProducts,
  order,
  listColor,
}) => {
  const [showShippingDiscount, setShowShippingDiscount] = useState<boolean>(false);

  if (freeShippingProducts.loading && order?.cart.delivery_tax) {
    return <ListProductsLoad />;
  }

  if (freeShippingProducts.loading || freeShippingProducts.products.length === 0) {
    return null;
  }

  return (
    <section>
      <div className="section-header" style={{ lineHeight: 1, color: listColor }}>
        <h1 className="mb-0 section-header border-0">Quer ganhar FRETE GRÁTIS?</h1>
        <div
          className="font-weight-normal d-flex align-items-baseline"
          style={{ fontSize: '0.8rem' }}
        >
          <span>Adicione um dos itens abaixo e ganhe frete grátis, consulte os regulamentos</span>
          <button
            className="btn btn-sm text-primary p-0"
            style={{ fontSize: '0.8rem', marginLeft: '0.1rem' }}
            onClick={() => setShowShippingDiscount(true)}
          >
            aqui
          </button>
          !
        </div>

        <ShippingDiscountModal
          show={showShippingDiscount}
          setShow={setShowShippingDiscount}
          showDiscounts={false}
        />
      </div>

      <Suspense fallback={<div />}>
        <Products products={freeShippingProducts.products} keyName="free" />
      </Suspense>
    </section>
  );
};

export default FreeShippingSection;
